<template>
  <section class="section level l2" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="header">
        <div class="backBtn" v-on:click="close"></div>
      </div>
      <div class="menuCnt">
        <h4>Riwayat perolehan point</h4>
        <div class="menuSc">
          <div class="menuItem loadingPrice" v-if="loading"></div>
          <div v-else>
            <div class="menuItem" v-for="(item, i) in history" :key="i">
              <div class="menuIcon" v-if="item.challenge"
                :style="{'background-color': item.challenge.color}">
                <div class="iconImg" v-if="item.challenge.media && item.type === 'challenge'"
                  :style="{'background-image': `url(${item.challenge.media.imageTh})`}"></div>
                <div class="iconShare" v-else></div>
              </div>
              <p>{{item.dateCreated | moment("ddd, D MMM YYYY HH:mm")}}</p>
              <h4 v-if="item.challenge">
                {{item.challenge.name}}
              </h4>
              <div class="point">{{item.point}}<sup>pts</sup></div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <Confirmation ref="confirmDialog"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';

export default {
  name: 'home',
  components: { Confirmation },
  data() {
    return {
      loading: true,
      show: false,
      history: [],
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    open() {
      this.show = true;
      this.loading = true;
      this.getData();
    },
    close() {
      this.show = false;
    },
    doNothing() {},
    getData() {
      this.$http.get(this.$config.uri('user/point/history')).then((r) => {
        this.loading = false;
        this.history = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.section.level.l2{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    right: 0; top: 0; bottom: 0;
    background-color: #e6e1c1;
    padding: 0 10px 40px;
    box-sizing: border-box;
    width: 380px;
    z-index: 3;
    right: -380px;
    transition: all .4s ease;
    @media (max-width: 680px) {
      width: 94%; right: -94%;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      right: 0;
    }
  }
  .header{
    padding: 16px 20px 10px;
    @media (min-width: 480px) {
      padding-left: 10px;
    }
    .backBtn{
      width: 46px; height: 46px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-next-black.png);
      background-size: 22px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      margin: 16px 0 14px;
      color: #444;
    }
  }
  .profilePict{
    width: 94px; height: 94px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 0 auto 16px;
    background-position: center;
    background-size: cover;
  }
  .profileInfo{
    text-align: center;
    padding-bottom: 20px;
    h4{
      margin: 0;
      font-size: 20px;
    }
    p{
      margin: 0;
      font-size: 15px;
    }
  }
  .expCnt{
    background-color: rgba(255, 255, 255, .7);
    margin: 0 10px 10px;
    border-radius: 10px;
    padding: 16px 20px 20px;
    position: relative;
    h4{
      margin: 0 0 6px;
      font-size: 16px;
    }
    .expLabel{
      position: absolute;
      right: 20px; top: 18px;
      font-size: 14px;
    }
    .theExp{
      height: 12px;
      background-color: #ccc;
      border-radius: 50px;
      .exp{
        height: 100%;
        max-width: 100%;
        background-color: #8EC642;
        // background-color: #6aa722;
        border-radius: 50px;
      }
    }
    .info{
      font-size: 12px;
      color: #555;
      text-align: right;
      margin: 5px 5px 0;
    }
  }
  .progressCnt{
    background-color: rgba(255, 255, 255, .7);
    margin: 0 10px;
    border-radius: 10px;
    padding: 16px 20px 52px;
    h4{
      margin: 0 0 10px;
    }
    .theProgress{
      display: flex;
      height: 80px;
      justify-content: space-between;
      .progressItem{
        height: 100%;
        font-size: 10px;
        text-align: center;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: relative;
        .label{
          position: absolute;
          left: 50%; margin-left: -15px;
          text-align: center;
          bottom: -34px;
          width: 30px;
          span{
            display: block;
            font-size: 14px;
            font-weight: bold;
            margin-top: -1px;
          }
        }
        .progress{
          width: 8px;
          background-color: #8EC642;
          background-color: #6aa722;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
    }
  }
  .pointHistory{
    padding: 14px 20px 12px;
    font-weight: bold;
    color: #444;
    position: relative;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 10px 10px;
    border-radius: 10px;
    font-size: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    transition: all .3s ease;
    cursor: pointer;
    padding-left: 48px;
    &:before{
      content: "";
      position: absolute;
      left: 10px; top: 5px; bottom: 5px; width: 30px;
      background-image: url(../assets/history.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .8;
    }
    &:hover{
      background-color: rgba(255, 255, 255, .8);
    }
    .more{
      position: absolute;
      right: 12px; top: 12px;
      width: 20px; height: 20px;
      background-position: center;
      background-size: 16px auto;
      background-repeat: no-repeat;
      background-image: url(../assets/arrow-right-black.png);
      opacity: .3;
    }
  }
  .menuCnt{
    padding: 10px 0 40px;
    .menuSc{
      position: absolute;
      left: 0; right: 0;
      top: 110px; bottom: 0;
      border-top: rgba(0, 0, 0, 0.1) 1px solid;
      padding: 10px 10px 40px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      overflow-y: auto;
    }
    h4{
      margin: 0 20px 6px;
    }
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 12px 100px 14px 64px;
      font-weight: bold;
      color: #444;
      position: relative;
      background-color: rgba(255, 255, 255, .6);
      background-color: #fff;
      // background-image: linear-gradient(to left, #8EC642, #669922);
      // color: #fff;
      margin: 0 10px 10px;
      border-radius: 5px;
      font-size: 16px;
      box-sizing: border-box;
      .menuIcon{
        position: absolute;
        left: 10px; top: 13px; height: 42px; width: 42px;
        border-radius: 3px;
        background-color: #ddd;
        // background-color: rgba(0, 0, 0, .1);
        .iconImg{
          position: absolute;
          left: 0; right: 0; bottom: 0; top: 0;
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
        }
        .iconShare{
          position: absolute;
          left: 0; right: 0; bottom: 0; top: 0;
          background-position: center;
          background-size: 20px auto;
          background-repeat: no-repeat;
          background-image: url(../assets/sharing.png);
        }
      }
      .point{
        position: absolute;
        right: 20px; top: 10px;
        font-size: 24px;
        sup{
          font-weight: normal;
          font-size: 14px;
          color: #767676;
          margin-left: 3px;
        }
      }
      &.loadingPrice{
        background-color: rgba(255, 255, 255, 0.5);
        background-color: transparent;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 36px auto;
        height: 60px;
      }
      h4{
        font-size: 16px;
        margin: 0;
      }
      p{
        margin: 0 0 4px;
        font-weight: normal;
        font-size: 14px;
        color: #767676;
      }
    }
  }
}
</style>
